module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.$t('app_edit')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_baseInfo')) + " ")]), _vm._v(" "), _c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceName')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.terminalName ? _vm.detail.terminalName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNo')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.terminalNo ? _vm.detail.terminalNo : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.typeName ? _vm.detail.typeName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_model')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.modelName ? _vm.detail.modelName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_firm')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.manufName ? _vm.detail.manufName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.mechName ? _vm.detail.mechName : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "calc(100% - 10px)"
    },
    attrs: {
      "label": _vm.$t('app_addres')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.address ? _vm.detail.address : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.memo ? _vm.detail.memo : '-') + "\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_softinfo')) + " ")]), _vm._v(" "), _c('el-row', {
    staticClass: "gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.ter_status')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.terminalStatus ? _vm.sstatus[_vm.detail.terminalStatus] : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.list.ztgxsj')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.updateTime ? _vm.detail.updateTime : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appVer')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.apkVersion ? _vm.detail.apkVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_srcver')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.resourceVersion ? _vm.detail.resourceVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.system_version')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.sysVersion ? _vm.detail.sysVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.system_spversion')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.spVersion ? _vm.detail.spVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_rots_5')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.mtVersion ? _vm.detail.mtVersion : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.hard_info')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.hardware ? _vm.detail.hardware : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.Electric_quantity')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.bat ? _vm.detail.bat : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "IMEI"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.imei ? _vm.detail.imei : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('terminal.details.network')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.rssi ? _vm.detail.rssi : '-') + "\n\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": _vm.labelttw
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.dest_status')
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.detail.activeStatus ? _vm.detail.activeStatus : '-') + "\n\t\t\t\t\t\t")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a50b2b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nonintelligent/device/detail.vue
// module id = 1014
// module chunks = 0